<template>
    <div class="box">
        <div class="box2">
            <div class="complaintInformation">
                <div class="operatingMechanism border_bottom">
                    <div class="left">指挥中心</div>
                    <div class="right">{{institution}}</div>
                </div>
            </div>
            <div class="uploadBox">
              <upload :imgUrl="imgUrl"></upload>
            </div>
            <div class="remark">
                <div class="titleName">上报原因</div>
                <div class="notAccepted">
                    <van-field
                    placeholder="请输入原因..."
                    type="textarea"
                    v-model="value"
                    maxlength="500"
                    @input="change"
                        />
                   <span class="total">{{currentTotal}}/500</span>
                </div>
            </div>

            <div class="btn">
                <div class="submit">
                    <van-button type="primary" @click="affirmBtn">确认上报</van-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import api from '../../../../service/modules/complaintApis'
    import util from '../../../../utils/common'
    import upload from '@/components/uploadCopy'
    export default {
        components: {
            upload
        },
        data () {
            return {
                currentTotal: 0,
                institution: '',
                // people: this.$store.state.complaint.userInfo.name,
                reportType: 'report',
                value: '',
                // id: util.getJsonLocal('item').id,
                item: util.getJsonLocal('item'),
                // isShowBtn: false
                flag: false,
                imgUrl: [] // 上传的图片
                // isback:this.$store.state.complaint.isBackDetail||util.getJsonLocal('isBack'),
                // userInfo:this.$store.state.complaint.userInfo||util.getJsonLocal('userInfoComplaint')
            }
        },
        mounted(){
            this.$on('fileUploadData', val => {
                this.imgUrl = val
            })
        },
        created () {
            this.getOrign();
            
        },
        computed: {
        },
        methods: {
            getOrign () {
                api.worker.getPcenter({}).then((res) => {
                    if (res.ret === 0) {
                        this.institution = res.data.fullName;
                    }
                })
            },
            change () {
                this.currentTotal = this.value.trim().length;
            },
            affirmBtn () {
                // this.isShowBtn = true;
                if (this.value === '' || this.value === 'undefined' || this.value === null) {
                    this.$Toast('上报原因不能为空');
                    return;
                }
                let params = {
                    // type: this.reportType, // 操作类型
                    reportContent: this.value, // 上报原因
                    id: this.item.id,
                    urls:this.imgUrl
                }
                if (this.flag === false) {
                    this.flag = true;
                    api.worker.report(params).then(res=>{
                        console.log(res);
                        if(res.ret==0){
                            this.$Toast('上报成功');
                            this.$router.back();
                            //  this.isShowBtn = true;
                        }
                    })
                }
                // if (this.$store.state.complaint.userInfo.unitType === 'center') {
                //     // 指挥中心
                //     api.report(data).then(res => {
                //         if (res.ret === 0) {
                //             this.$Toast('操作成功');
                //             if(!this.isback){
                //               this.$router.go(-2);
                //             }else{
                //                 this.$router.back();
                //                 this.$set(this.itemList,'btns',[]);
                //                 util.setJsonLocal('item',this.itemList);
                //             }
                //             // this.$router.go(-2);
                            
                //         }
                //     })
                // } else {
                //     // 类型、企业、部门
                //     api.dOperation(data).then(res => {
                //         if (res.ret === 0) {
                //             this.$Toast('操作成功');
                //             if(!this.isback){
                //               this.$router.go(-2);
                //             }else{
                //                 this.$router.back();
                //                 this.$set(this.itemList,'btns',[]);
                //                 util.setJsonLocal('item',this.itemList);
                //             }
                //             // this.$router.go(-2);
                //         }
                //     })
                // }
            }

        }
    }
</script>
<style lang="less" scoped>
.box {
    width: 100%;
    padding: 14px;
    background-color: #f4f3f3;
    box-sizing: border-box;
    height: 100%;
    .box2 {
        width: 100%;
        padding: 14px;
        background-color: #fff;
        font-size: 14px;
        box-sizing: border-box;
        .uploadBox{
            margin-top: 20px;
        }
        .complaintInformation {
            width: 100%;
            .operatingMechanism,.operator,.acceptedLaborNumber,.inadmissibleReason {
                display: flex;
                height: 50px;
                line-height: 50px;
                .left {
                    float: left;
                    width: 50%;
                    text-align: left;
                    color: #aaa
                }
                .right {
                    float: left;
                    width: 50%;
                    text-align: right;
                }
            }
            .border_bottom {
                border-bottom: 1px solid #eee
            }
            .operatingMechanism {
                .right {
                    color: blue;
                }
            }
            .inadmissibleReason {
                .right {
                    color: #ddd;
                }
            }
        }
        .remark {
            width: 100%;
            margin-top: 20px;
            .titleName {
                color: #aaa;
                text-align: left;
            }
            .notAccepted {
                margin-top: 14px;
                position: relative;
                .van-cell {
                    font-size: 12px;
                    background: #efeded;
                    border-radius: 7px;
                }
                .total{
                    position: absolute;
                    bottom:6px;
                    right:6px;
                }
            }
        }
        .btn {
            margin-top: 30px;
            .van-button {
                width: 100%;
                border-radius: 7px;
                margin-top: 10px;
            }
            .back {
                .van-button {
                    color: #bdb8b8
                }
                .van-button--plain {
                    background-color: #efeded;
                }
            }
        }
    }
}
</style>
